(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-template"]) return;
  try {
    
  function initBlogTagSelector(root) {
    root.querySelectorAll('.Blog__TagSelector-select').forEach(function (tagSelector) {
      if (tagSelector.dataset.blogTagSelectorBound === 'true') return;

      tagSelector.dataset.blogTagSelectorBound = 'true';
      tagSelector.addEventListener('change', function (event) {
        window.location.href = window.location.origin + event.target.value;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBlogTagSelector(document);
    });
  } else {
    initBlogTagSelector(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBlogTagSelector(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-faq"]) return;
  try {
    
 function initRewardsFaq(root) {
   root.querySelectorAll('.reward-faq-main-wraper .accordion').forEach(function (accordion) {
     if (accordion.dataset.rewardsFaqBound === 'true') return;

     accordion.dataset.rewardsFaqBound = 'true';
     accordion.addEventListener('click', function () {
       this.classList.toggle('active');
       var panel = this.nextElementSibling;
       panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
     });
   });
 }

 if (document.readyState === 'loading') {
   document.addEventListener('DOMContentLoaded', function () {
     initRewardsFaq(document);
   });
 } else {
   initRewardsFaq(document);
 }

 document.addEventListener('shopify:section:load', function (event) {
   initRewardsFaq(event.target);
 });
 
  } catch(e) { console.error(e); }
})();
})();
